export { default, Icon } from '../components/icon';